

export default {
    nombre:"",
    url_img:"https://servidor-imagenes.eordering.pwstasp.com/ecommerce.png?bucket=eorderingpwst&token=eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJleHAiOjQ3NzczMTUyMDAsImRhdGEiOnsiYmFzZSI6InBjZzAxIiwidXN1YXJpbyI6InBjZ3Bvc3dlYiIsImZlY2hhIjoiNS8yMi8yMTIxIn0sImlhdCI6MTYxOTYzMTg0NX0.TZUjnrgHJotlJBR82pGbPXTDutxrsQ0SRBbQQLGAemc"
}